import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { CppReturnsService } from '../../../services/cpp-returns/cpp-returns.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';

// Class
import { DashboardFilter } from '../../../models/DashboardFilter';
import { MasterConstants } from '../../../common/constants/master-constants';
import { ContainerReturnService } from '../../../services/container-return/container-return.service';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-container-returns-review',
  templateUrl: './container-returns-review.component.html',
  styleUrls: ['./container-returns-review.component.scss']
})
export class ContainerReturnsReviewComponent implements OnInit, AfterViewInit, OnDestroy {
  errorMsgs = new Array();
  showErrorBlock = false;
  currentErrorRow = 1;
  nextErrorId = 0;
  nextLotNumber: string;
  // Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  shipToAccountItems: any[];
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  searchValue = '';
  partialSearchValue = '';
  invoiceNumberList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'returnType', 'itemNumber', 'serialNumber', 'requestedUnits', 'uom', 'packageSize', 'notes'];
  isParent = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  shipToDataLoading = true;
  index: any;
  returnRequestNumber = 0;
  returnRequestId = 0;
  accountEmail: string;
  readOnlyAccess = false;
  userMenuAccessList: any;
  dsmInfo: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess = false;
  createRequestAccess = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate = true;
  requestStatus: string;
  isValidLineStatus = false;
  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  showSubmitToJde = false;
  showSubmitReturn = false;
  breadcrumbtext: string;
  showScaleDelete = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete = false;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending = true;;
  validateEvolveData: any;
  disableRejectedLine = true;
  isIncreaseQtyEnable = true;
  isDecreaseQtyEnable = true;
  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  soldToFacility: any[];
  soldToAccount: number;
  shipToAddress: string;
  soldToaccountName: string;
  soldToaddress: string;
  shipToAcnumber: string;
  soldToAcnumber: string;
  isShowNonSubEmail = true;

  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public cppReturnsService: CppReturnsService,
    public containerReturnsService: ContainerReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.containerReturnsService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CPP_RETURNS_PRODUCTS);

          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          // Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x['containerReturnRequestId']) {
              this.returnRequestId = +x['containerReturnRequestId'];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }));
        }
        this.enableCreate = true;
      }
    }

    this.productAllDataSource = new MatTableDataSource([]);
    this.containerReturnsService.setEditModeStatus(false);
    this.errorMsgs = new Array();
  }

  // Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnsService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      if (result) {
        if (result.returnRequestStatus !== 'DRAFT' && result.returnRequestStatus !== 'ERROR') {
          this.router.navigate([`/container-returns/products-confirmation/${this.returnRequestId}`]);
        }
        else {
          this.breadcrumbtext = 'Review Return Request [' + result.returnRequestNumber + ']';
          this.containerReturnsService.setEditModeStatus(true);
          this.isPickupDateValid = true;
          this.isNameValid = true;
          this.isContactValid = true;
          this.isPalletValid = true;
          this.containerReturnsService.returnRequestStatus = result.returnRequestStatus;
          this.accountEmail = result.email;
          this.requestStatus = result.returnRequestStatus;
          this.enableCreate = false;
          this.editApprovalList = result;
          if (result.containerReturnsProductList && result.containerReturnsProductList.length > 0) {
            result.containerReturnsProductList.forEach(x => {
              x.isSelected = false;
              // x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
              x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotSerialNumber, 'errors': [] };
              x.lineError = false;
              x.lotNumber = x.lotSerialNumber;
              if (!this.isApprovalAccess && x.lineStatus == 'PENDING') {
                x.isIncreaseQtyDisable = true;
                x.isDecreaseQtyDisable = true;
              }
              else if (!this.isApprovalAccess && x.lineStatus == 'APPROVED') {
                x.isIncreaseQtyDisable = true;
              }
            });
          }
          this.returnRequestNumber = result.returnRequestNumber;
          this.shipToAccount = result.shipToAccountId;
          this.shipToAccountName = result.shipToAccountName;
          this.containerReturnsService.setSelectedAccountNo(this.shipToAccount);
          this.dsmInfo = result.dsmName;
          this.isParent = result.isParent;
          this.containerReturnsService.setProductList(result.containerReturnsProductList);
          this.bindDataSource(result.containerReturnsProductList, true);
          this.requestedByUser = result.requestedBy;
          this.onBehalfUser = result.requestedBy;
          this.getUserList(this.shipToAccount);

          this.containerReturnsService.setSelectedAccountNo(result.shipToAccountId);
          const approvedItem = result.containerReturnsProductList.filter(x => x.lineStatus == 'APPROVED');
          if (approvedItem.length > 0) {
            this.isRequestPending = false;
          }

          this.contactName = result.pickupInfo.contactName;
          this.contactNumber = result.pickupInfo.contactNumber;
          this.customerPONumber = result.pickupInfo.custPONumber;
          // this.palletCount = result.pickupInfo.palletCount;
          this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
          this.deliveryAccount = result.pickupInfo.pickUpLocation;
          this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
          this.shippingInstructions = result.pickupInfo.shippingInstructions;
          this.selectedFreightInstruction = result.pickupInfo.freightInstructions;
          this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
          this.shipToAddress = result.shipToAccount.address1;
          this.soldToaccountName = result.soldToAccount.accountName;
          this.soldToaddress = result.soldToAccount.address1;
          this.soldToAcnumber = result.soldToAccount.accountNumber;
          this.soldToAccount = result.soldToAccount.accountNumber;
          this.shipToAcnumber = result.shipToAccount.accountNumber;
        }
      }
      else {
        this.router.navigate(['/container-returns/dashboard-products']);
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getUserList(accountNumber) {
    const self = this;
    this.subscription.add(this.cppReturnsService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          const accountNameArr = x.userName.split(',');
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + ' ' + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        // if (this.currentRequestedUser) {
        //  let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        //  this.requestedByUser = requestItem[0].userId;
        // }
        if (this.onBehalfUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          if (requestItem) {
            this.onBehalfUserName = requestItem[0].userName;
            this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
            this.requestedByUser = requestItem[0].userId;
          }
        }

        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  backToRequest() {
    this.router.navigate(['/container-returns/request-products', this.returnRequestId]);
  }

  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submitJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    this.editApprovalList.isUpdateRequest = true;
    const productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    const newLineItems = [];
    productList.filter(x => {
      if (x.lineStatus === '' || x.lineStatus === null) {
        newLineItems.push(JSON.parse(JSON.stringify(x)));
        x.lineStatus = 'PENDING';
      }
      x.errorMessage = null;
    });

    const containerReturnProductList = new Array<any>();
    productList.map((x) => {
      const containerReturnProduct = {
        containerItemId: x.containerItemId,
        containerFillStatus: x.containerFillStatus,
        containerItemDescription: x.containerItemDescription,
        containerItemNumber: x.containerItemNumber,
        containerReturnRequestDetailId: x.containerReturnRequestDetailId,
        customerNotes: x.customerNotes,
        errorMessage: x.errorMessage,
        isSelected: x.isSelected,
        itemId: x.itemId,
        itemDescription: x.containerItemDescription,
        itemVendorName: x.itemVendorName,
        lineStatus: x.lineStatus,
        lotNumber: x.lotSerialNumber,
        packageSize: x.packageSize,
        returnQuantity: x.returnQuantity,
        uom: x.um,
        unitPrice: x.unitPrice
      };
      containerReturnProductList.push(containerReturnProduct);
      return x;
    });
    const item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    const postData = {
      ContainerReturnRequestId: this.editApprovalList.containerReturnRequestId,
      ReturnRequestType: this.editApprovalList.returnRequestType,
      ReturnRequestStatus: this.editApprovalList.returnRequestStatus,
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      SoldToAccount: this.soldToAccount,
      IsUpdateRequest: this.editApprovalList.isUpdateRequest,
      DsmId: this.editApprovalList.dsmId,
      DsmName: this.dsmInfo,
      EmailUserName: (this.selectedUserName ? this.selectedUserName : null),
      BranchPlant: null,
      ContainerReturnProductList: containerReturnProductList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      ProductLine: null,
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString('en-US') : null),
        ContactName: (this.contactName ? this.contactName : ''),
        ContactNumber: (this.contactNumber ? this.contactNumber : ''),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        FreightInstructions: this.selectedFreightInstruction,
        PalletCount: (this.palletCount ? Number(this.palletCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : '')
      },
    };

    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnsService.submitToJDEReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        const errorCount = result.containerReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data.forEach(x => {
            const item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            const containerReturnProductError = result.containerReturnProductList.filter(e => e.itemId == x.itemId && e.lotNumber == x.lotNumber && e.lineError == true)[0];

            if (containerReturnProductError) {
              if (containerReturnProductError.errorMessage != '' && containerReturnProductError.errorMessage != null) {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [{ 'error': containerReturnProductError.errorMessage }] };
                x.lineError = true;
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
                x.lineError = true;
              }
            }
          });
          this.getCommonErrors(this.errorMsgs);
          this.loaderService.setLoaderStatus(false);
        } else {
          const successMsg = 'Return Request submitted successfully.';
          this.toastrService.success(successMsg);
          this.router.navigate([`/container-returns/products-confirmation/${this.returnRequestId}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Return Request not saved in the system.');
    }));
    // }
  }

  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }
}
